import { Loader2, AlertCircle } from 'lucide-react'

export function RendererLoading({ label }: { label?: string }) {
  return (
    <div className="flex-1 flex items-center justify-center">
      {label ? (
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-[var(--text-secondary)] mx-auto mb-2" />
          <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>{label}</p>
        </div>
      ) : (
        <Loader2 className="h-8 w-8 animate-spin text-[var(--text-secondary)]" />
      )}
    </div>
  )
}

export function RendererError({ message }: { message: string }) {
  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="text-center">
        <AlertCircle className="h-12 w-12 text-destructive mx-auto mb-4" />
        <p className="text-destructive font-medium">{message}</p>
      </div>
    </div>
  )
}
